module.exports = __webpack_public_path__ + "static/flexivel-00fd7ba56b8e5addd6df53cc625a5d15.svg";